import {fetchFromApi, fetchModuleData, getBackendApiURL, NetworkData} from "../../../BackendFacade";
import {IValueContainer} from "../../../Utils/IValueContainer";
import {IRepo, ISecret, ITeam} from "../Interfaces/IGithub";

export async function getRepos(): Promise<IRepo[]> {
    const res = await fetchModuleData<IValueContainer<IRepo[]>>("repos", "GET");
    return res.Value
}

export function createRepo(
    projectId: string,
    moduleInstanceId: string,
    payload: { costCenter: string; repoName: string; visibility: "private" | "internal", teamSlug: string },
): Promise<NetworkData> {
    const url = getBackendApiURL() + `projects/${projectId}/modules/${moduleInstanceId}/repos`;
    return fetchFromApi(url, "POST", payload);
}

export function deleteRepo(
    projectId: string,
    moduleInstanceId: string,
    repoName: string
): Promise<NetworkData> {
    const url = getBackendApiURL() + `projects/${projectId}/modules/${moduleInstanceId}/repos?repoName=${encodeURIComponent(repoName)}`;
    return fetchFromApi(url, "DELETE");
}

export async function getSecrets(): Promise<ISecret[]> {
    const res = await fetchModuleData<IValueContainer<ISecret[]>>("secrets", "GET");
    return res.Value
}

export async function getTeams(): Promise<ITeam[]> {
    const res = await fetchModuleData<IValueContainer<ITeam[]>>("teams", "GET");
    return res.Value
}

export function createAndUpdateSecret(
    projectId: string,
    moduleInstanceId: string,
    payload: { secretName: string; secretValue: string; repoIDs?: string[] }
): Promise<NetworkData> {
    const url = getBackendApiURL() + `projects/${projectId}/modules/${moduleInstanceId}/secrets`;
    return fetchFromApi(url, "PUT", payload);
}

export function deleteSecret(
    projectId: string,
    moduleInstanceId: string,
    secretName: string
): Promise<NetworkData> {
    const url = getBackendApiURL() + `projects/${projectId}/modules/${moduleInstanceId}/secrets?secretName=${encodeURIComponent(secretName)}`;
    return fetchFromApi(url, "DELETE");
}
